import { c as _c } from "react/compiler-runtime";
import { ReactElement, memo } from 'react';
import ButtonComponent from '../button/button/button.component';
import { ButtonType } from '@spa/components/button/types/ButtonType';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import logger from '../../lib/logger';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Product {
  readonly name: string;
}
export interface Props {
  readonly buttonType: ButtonType;
  readonly disabled?: boolean;
  readonly product: Product;
  readonly text?: string;
  readonly uppercase?: boolean;
}
function ReminderButtonComponent(t0) {
  const $ = _c(11);
  const {
    buttonType,
    disabled,
    product,
    text,
    uppercase
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("product-tile");
  let t1;
  if ($[0] !== product.name) {
    t1 = () => {
      logger.info("You are trying to add a reminder for the product: [ProductName: %s]", product.name);
    };
    $[0] = product.name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const addReminder = t1;
  let t2;
  if ($[2] !== formatMessage || $[3] !== text) {
    t2 = text ?? formatMessage("reminder");
    $[2] = formatMessage;
    $[3] = text;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const buttonText = t2;
  let t3;
  if ($[5] !== addReminder || $[6] !== buttonText || $[7] !== buttonType || $[8] !== disabled || $[9] !== uppercase) {
    t3 = <ButtonComponent buttonType={buttonType} disabled={disabled} onClick={addReminder} text={buttonText} uppercase={uppercase} />;
    $[5] = addReminder;
    $[6] = buttonText;
    $[7] = buttonType;
    $[8] = disabled;
    $[9] = uppercase;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
export default memo(ReminderButtonComponent);